<template>
  <page-template type="norightpanel">
    <template v-slot:toolbar>
      <tool-bar type="results" title="Nom action" linkback="/action-collaborative" class="px-8"></tool-bar>
    </template>
    <template v-slot:main-panel-content>
      <div class="mx-8 results-enquete">
        <div class="d-flex justify-space-between pa-4 results-header">
          <p>Réponses : <strong>2</strong></p>
          <div class="d-flex">
            <div class="d-flex cursor-pointer ml-2 mr-4">
              <p>Exporter en</p>
              <v-img src="/images/download_pdf.png" width=30 height=30 class="mx-3"></v-img>
            </div>
            <div class="d-flex cursor-pointer ml-4 mr-2">
              <p>Exporter en</p>
              <v-img src="/images/download_xls.png" width=30 height=30 class="mx-3"></v-img>
            </div>
          </div>
        </div>
        <div class="pa-4 results-content">
          <p class="text-uppercase mb-4">1. Question 1</p>
          <div class="d-flex align-baseline justify-space-between my-2 anwser">
            <p class="my-auto percentage">70%</p>
            <div class="d-flex mx-6 my-auto progress-bar">
              <p class="white_">Réponse 1</p>
              <v-progress-linear
                value="70"
                height="30"
                rounded
              ></v-progress-linear>
            </div>
            <p class="my-auto">2</p>
          </div>
          <div class="d-flex justify-space-between my-2 anwser">
            <p class="my-auto percentage">30%</p>
            <div class="d-flex mx-6 my-auto progress-bar">
              <p class="white_">Réponse 2</p>
              <v-progress-linear
                value="30"
                height="30"
                rounded
              ></v-progress-linear>
            </div>
            <p class="my-auto">2</p>
          </div>
          <div class="d-flex justify-space-between my-2 anwser">
            <p class="my-auto percentage">0%</p>
            <div class="d-flex mx-6 my-auto progress-bar">
              <p class="white_">Réponse 3</p>
              <v-progress-linear
                value="0"
                height="30"
                rounded
              ></v-progress-linear>
            </div>
            <p class="my-auto">2</p>
          </div>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'ActionCollaborativeReponses',
    components: { pageTemplate, toolBar },
    data: () => {
      return {}
    },
    async created () {
      try {
        // RESPONSES OF A FINISHED COLLABORATIVE ANSWER
        const pollResponsesRes = await axios.get(`${apiURL}/polls/responses/[:id]`)
        this.pollResponses = pollResponsesRes.data
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      }
    }
  }
</script>